/**
 * 展示层格式化工具
 */

/**
 * 格式化价格用于展示（统一半角 ¥）。
 *
 * 背景（2026-10-21）：闲鱼商品卡片的 priceInfo 是 {preText: '¥', price: '3.88'}，
 * 采集端历史实现把 preText 直接拼进 item_info.item_price，库里存成了「¥3.88」；
 * 而卡片模板自己还会补一个「¥」，于是页面显示成「¥¥3.88」。
 *
 * 这里做兜底：已经带符号的值先剥掉再统一补一个，既修复存量脏数据，
 * 也不需要动数据库。纯文本价格（如「面议」「价格未知」）原样返回，不强行加符号。
 */
export const formatPrice = (value?: string | number | null): string => {
  if (value === undefined || value === null) return '-';
  const text = String(value).trim();
  if (!text) return '-';
  if (/^[¥￥]/.test(text)) {
    return `¥${text.replace(/^[¥￥]\s*/, '')}`;
  }
  if (/^\d/.test(text)) {
    return `¥${text}`;
  }
  return text;
};
